<grid-virtual-scroll-viewport class="main-grid" (onScroll)="archiveListDataSource.onScroll($event)">
  <ng-container *gridVirtualFor="let rows of archiveListDataSource; itemMinWidth: minWidth; itemMaxWidth: maxWidth; minGap: minGap;">
    @for (item of rows; track item) {
      <li class="columns">
        <ngx-archive-card [archive]="item"></ngx-archive-card>
      </li>
    }
  </ng-container>
</grid-virtual-scroll-viewport>
